export default __webpack_public_path__ + "static/media/img_baseBunnyRattle_lemon_p.93c65c24.jpg";